import { DomainEvent } from 'src/app/core/domain/events/domain_event';

import { Subscription } from '../../subscription/subscription';

export class SubscriptionEvent extends DomainEvent<Subscription> {}

export class SubscriptionCancelled extends SubscriptionEvent {}
